import AppStorage from 'AppStorage';
import Config from 'Config';
import { EventType, PolicyPayload, QuestionCategories } from 'Constants';
import axios from 'axios';
import * as querystring from 'querystring';
import EventEmitter from 'utils/EventEmitter';
import { getEPFPayloadnew, mapPayloadNewProduct } from '../utils/epfToIProtect';
import { signWithJwt } from '../utils/jwt';

const baseUrl = Config.baseUrl || 'http://localhost:8088';
const saveBorwserConfig = Config.saveBorwserConfig;

class Network {
  constructor() {
    if (Network.instance) {
      return Network.instance;
    }

    Network.instance = this;

    this.eventEmitter = new EventEmitter();

    this.currentErrorCode = '';

    this.client = axios.create({
      baseURL: baseUrl,
      headers: {
        'Content-Type': 'application/json'
      },
      proxy: false

      // transformResponse: [
      //   data => {
      //     try {
      //       let obj = JSON.parse(data);

      //       // Payload contains an escaped json string
      //       // Parse it back into object if it is present
      //       if (obj.payload !== undefined && obj.payload !== null) {
      //         obj.payload = JSON.parse(obj.payload);
      //       }
      //       return obj;
      //     } catch (e) {
      //       // Cannot parse as json, something is probably wrong
      //       return data;
      //     }
      //   }
      // ]
    });

    this.client.interceptors.request.use(
      (config) => {
        if (!config.turnOffLoading) {
          this.eventEmitter.emit(EventType.loading, true);
        }

        console.log('API request:', config.url);
        console.log({
          ...config.data,
          payLoad: !!config.data.payLoad && JSON.stringify(config.data.payLoad)
        });
        return config;
      },
      (error) => {
        // Do something with request error
        return Promise.reject(error);
      }
    );

    this.client.interceptors.response.use(
      (response) => {
        this.eventEmitter.emit(EventType.loading, false);

        console.log('API response:', response);
        return response;
      },
      (error) => {
        this.eventEmitter.emit(EventType.loading, false);

        console.log('API response error:', error);

        if (error.response) {
          const c2lEvent = (element) => element.errorField === 'C2L';
          if (error.response.data.errorDetails?.some(c2lEvent)) {
            this.eventEmitter.emit(EventType.C2LDown);
          } else {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log('API response error.response', error.response);
            if (this.currentErrorCode) {
              error.response.errorCode = this.currentErrorCode;
            }
            this.eventEmitter.emit(EventType.responseError, error.response);
            this.currentErrorCode = '';
          }
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser
          // and an instance of http.ClientRequest in node.js
          console.log('API response error.request', error.request);
          this.eventEmitter.emit(EventType.connectionDown, error.request);
        } else {
          // Something happened in setting up request that triggered an Error
          console.log('API response error.message', error.message);
          this.eventEmitter.emit(EventType.responseError, error.message);
        }

        return Promise.reject(error);
      }
    );

    return this;
  }

  /**
   * Mimic axios.all() call
   * @param {Promise<any[]>[]} requests - Array of requests to be
   * called concurrently
   * @returns {Promise<any[]>} - Promise resolving to array of responses
   */
  all = (requests) => {
    return axios.all(requests);
  };

  stringifyRequestData = (data) => {
    const { payLoad } = data;
    if (!payLoad) {
      return {
        ...data,
        payLoad: ''
      };
    }

    const stringPayLoad = JSON.stringify(payLoad);
    // Just for copy and paste development
    // console.log(stringPayLoad);
    return {
      ...data,
      payLoad: stringPayLoad
    };
  };

  parseResponseData = (data) => {
    const { payLoad: responsePayLoad } = data;
    // console.log('1', responsePayLoad);
    if (!responsePayLoad) {
      return data;
    }

    const { payLoad } = responsePayLoad;
    // console.log('2', payLoad);
    if (!payLoad) {
      return data;
    }

    const parsedPayLoad = JSON.parse(payLoad);
    data.payLoad = {
      ...responsePayLoad,
      payLoad: parsedPayLoad
    };
    return data;
  };

  getRibbonPromoData = async (environment, apiKey, accessToken, currentLanguage) => {
    let lang = currentLanguage === 'en' ? 'en-us' : 'ms-my';

    try {
      return await fetch(
        `https://cdn.contentstack.io/v3/content_types/old_ecom_ribbon_default_promo/entries?branch=capricorn&environment=${environment}&locale=${lang}`,
        {
          headers: {
            'Content-Type': 'application/json',
            api_key: apiKey,
            access_token: accessToken
          }
        }
      )
        .then((response) => response.json())
        .catch((error) => console.error(error));
    } catch (error) {
      console.error('getPhoto error:', error);
    }
  };
  getLeadData = async (environment, apiKey, accessToken) => {
    try {
      return await fetch(
        // `https://app.contentstack.com/#!/stack/blt3333609892cab36e/content-type/leads_page/en-us/entry/bltf68a454c7d3a0413/edit?branch=main`,
        `https://cdn.contentstack.io/v3/content_types/old_ecom_leads_page/entries?branch=capricorn&environment=${environment}&locale=en-us`,
        {
          headers: {
            'Content-Type': 'application/json',
            api_key: apiKey,
            access_token: accessToken
          }
        }
      )
        .then((response) => response.json())
        .catch((error) => console.error(error));
    } catch (error) {
      console.error('getPhoto error:', error);
    }
  };

  getPopupPromoData = async (environment, apiKey, accessToken) => {
    try {
      return await fetch(
        `https://cdn.contentstack.io/v3/content_types/old_ecom_pop_up_reward/entries?branch=capricorn&environment=${environment}&locale=en-us&query={"type_of_promotion":"popup","is_active": true}`,
        {
          headers: {
            'Content-Type': 'application/json',
            api_key: apiKey,
            access_token: accessToken
          }
        }
      )
        .then((response) => response.json())
        .catch((error) => console.error(error));
    } catch (error) {
      console.error('getPhoto error:', error);
    }
  };

  getStripPromoData = async (environment, productsTargeted, apiKey, accessToken) => {
    try {
      return await fetch(
        `https://cdn.contentstack.io/v3/content_types/old_ecom_pop_up_reward/entries?branch=capricorn&environment=${environment}&locale=en-us&query={"type_of_promotion":"strip","is_active": true,"products_targeted":"${productsTargeted}"}`,
        {
          headers: {
            'Content-Type': 'application/json',
            api_key: apiKey,
            access_token: accessToken
          }
        }
      )
        .then((response) => response.json())
        .catch((error) => console.error(error));
    } catch (error) {
      console.error('getPhoto error:', error);
    }
  };

  validatePromoCode = async (productCode, data) => {
    const path = `api/${productCode}/promoCode`;
    const response = await this.doPost(path, data);
    return response;
  };

  saveBeforeQuotation = async (productCode, data, turnOffLoading = false) => {
    console.log('saveBeforeQuote', JSON.stringify(data));
    const requestData = this.stringifyRequestData(data);
    this.currentErrorCode = 'FE100';

    try {
      const response = await this.client.post(
        `/api/${productCode}/policy/saveQuotation`,
        requestData,
        { turnOffLoading }
      );
      if (!response || !response.data) {
        return null;
      }

      const responseData = this.parseResponseData(response.data);
      console.log('saveBeforeQuote response', responseData);
      return responseData;
    } catch (error) {
      console.error('saveBeforeQuote error', error);
      return null;
    }
  };

  savePolicy = async (productCode, data, turnOffLoading = false) => {
    const requestData = this.stringifyRequestData(data);
    console.log('savePolicy', requestData);
    this.currentErrorCode = 'FE110';

    try {
      const response = await this.client.post(`/api/${productCode}/policy/save`, requestData, {
        turnOffLoading
      });
      if (!response || !response.data) {
        return null;
      }

      const responseData = this.parseResponseData(response.data);
      console.log('savePolicy response', responseData);
      return responseData;
    } catch (error) {
      console.error('savePolicy error', error);
      return null;
    }
  };
  ismApplication = async (idNumber, data) => {
    console.log('ismEnquiry', JSON.stringify(data));
    const ismEnquiryRequest = data;
    this.currentErrorCode = 'FE190';

    try {
      const response = await this.client.post(
        `/api/ism/enquiry?nRICNumber=${idNumber}`,
        ismEnquiryRequest
      );
      if (!response || !response.data) {
        return null;
      }

      const responseData = this.parseResponseData(response.data);
      console.log('ismEnquiry response', responseData);
      return responseData;
    } catch (error) {
      console.error('ismEnquiry error', error);
      return null;
    }
  };

  refreshQuote = async (productCode, data, turnOffLoading = false) => {
    console.log('refreshQuote', JSON.stringify(data));
    const requestData = this.stringifyRequestData(data);
    this.currentErrorCode = 'FE120';
    try {
      const response = await this.client.post(`/api/${productCode}/refreshQuotation`, requestData, {
        turnOffLoading
      });
      if (!response || !response.data) {
        return null;
      }

      const responseData = this.parseResponseData(response.data);
      console.log('refreshQuote response', responseData);
      return responseData;
    } catch (error) {
      console.error('refreshQuote error', error);
      return null;
    }
  };

  saveBrowserStorage = async (data, policyRefNoData) => {
    if (saveBorwserConfig.enabled) {
      let policyRefNo;
      const PolicyPayload = JSON.parse(sessionStorage.getItem('PolicyPayload'));
      if (sessionStorage.getItem('PolicyPayload')) {
        if (Array.isArray(PolicyPayload)) {
          policyRefNo = PolicyPayload.filter(
            (PolicyPayload) => PolicyPayload.custList.length < 2
          )[0].referenceNo;
        } else {
          policyRefNo = PolicyPayload.quotationId;
        }
      }
      const requestData = {
        policyRefNo: policyRefNoData ? policyRefNoData : policyRefNo,
        sessionStorage: JSON.stringify(sessionStorage, undefined, 4),
        localStorage: data ? data : JSON.stringify(localStorage, undefined, 4)
      };
      try {
        const response = await this.client.post(`/api/policy/saveBrowserStorage`, requestData);
        if (!response || !response.data) {
          return null;
        }

        const responseData = this.parseResponseData(response.data);
        console.log('refreshQuote response', responseData);
        return responseData;
      } catch (error) {
        console.error('refreshQuote error', error);
        return null;
      }
    }
  };

  getQuote = async (productCode, data, turnOffLoading = false) => {
    console.log('getQuote', JSON.stringify(data));
    const requestData = this.stringifyRequestData(data);
    this.currentErrorCode = 'FE120';
    try {
      const response = await this.client.post(`/api/${productCode}/quotation`, requestData, {
        turnOffLoading
      });
      if (!response || !response.data) {
        return null;
      }

      const responseData = this.parseResponseData(response.data);
      console.log('getQuote response', responseData);
      return responseData;
    } catch (error) {
      console.error('getQuote error', error);
      return null;
    }
  };

  initUnderwriteMe = async (productCode, data) => {
    // console.log('network underwriteMeInitial', data);
    const requestData = this.stringifyRequestData(data);
    this.currentErrorCode = 'FE130';

    try {
      const response = await this.client.post(
        `/api/${productCode}/underwriteMe/initial`,
        requestData
      );

      const responseData = this.parseResponseData(response.data);
      // console.log('underwriteMeInitial response', responseData);
      return responseData;
    } catch (error) {
      console.error('underwriteMeInitial error', error);
      return null;
    }
  };

  answerUnderwriteMe = async (productCode, data) => {
    // console.log('network underwriteMeAnswer', data);
    const requestData = this.stringifyRequestData(data);
    this.currentErrorCode = 'FE140';

    try {
      const response = await this.client.post(
        `/api/${productCode}/underwriteMe/answer`,
        requestData
      );
      if (!response || !response.data) {
        return null;
      }

      const responseData = this.parseResponseData(response.data);
      // console.log('underwriteMeAnswer response', responseData);
      return responseData;
    } catch (error) {
      console.error('underwriteMeAnswer error', error);
      return null;
    }
  };

  filterConditions = (conditions, searchText, questionName) => {
    if (QuestionCategories[questionName]) {
      // QuestionCategories can be string or array
      if (Array.isArray(QuestionCategories[questionName])) {
        return conditions.filter(
          (condition) =>
            condition.text.toLowerCase().includes(searchText) &&
            // Check intersection of the two arrays
            QuestionCategories[questionName].filter((qc) => condition.categories.includes(qc))
              .length > 0
        );
      } else {
        return conditions.filter(
          (condition) =>
            condition.text.toLowerCase().includes(searchText) &&
            condition.categories.includes(QuestionCategories[questionName])
        );
      }
    } else {
      return conditions.filter((condition) => condition.text.toLowerCase().includes(searchText));
    }
  };

  lookupUnderwriteMeOptions = async (productCode, data, questionName) => {
    const searchText = data.toLowerCase();

    // When conditions cache exists just return the cache
    if (this.conditions && this.conditions.length > 0) {
      return this.filterConditions(this.conditions, searchText, questionName);
    }
    this.currentErrorCode = 'FE150';
    let policyPayload = AppStorage.getItem(PolicyPayload);

    try {
      const response = await this.client.post(
        `/api/${productCode}/underwriteMe/getLookupQuestionOptionList`,
        {
          payLoad: 'Conditions',
          // eslint-disable-next-line no-nested-ternary
          quotationId: policyPayload
            ? policyPayload.quotationId
              ? policyPayload.quotationId
              : ''
            : ''
        } // this will get all conditions which is more than 6000
      );
      if (!response || !response.data) {
        return null;
      }

      const responseData = this.parseResponseData(response.data);

      if (
        !responseData ||
        !responseData.payLoad ||
        !responseData.payLoad.payLoad ||
        !responseData.payLoad.payLoad.options
      ) {
        console.log('no options found');
        return [];
      }

      this.conditions = responseData.payLoad.payLoad.options.map((option) => ({
        text: option.text,
        categories: option.categories
      }));

      return this.filterConditions(this.conditions, searchText, questionName);
    } catch (error) {
      console.error('lookupUnderwriteOptions error', error);
      return [];
    }
  };

  getAllAnsweredQuestions = async (productCode, data) => {
    console.log('network getAllAnsweredQuestions', JSON.stringify(data));
    const requestData = this.stringifyRequestData(data);
    this.currentErrorCode = 'FE160';

    try {
      const response = await this.client.post(
        `/api/${productCode}/underwriteMe/enquiryForAnsweredQuestion`,
        requestData
      );
      if (!response || !response.data) {
        return null;
      }

      // let response = {
      //   data: {
      //     result: 'SUCCESS',
      //     payLoad: {
      //       quotationId: 46462,
      //       enquireKey: 'b2542632606a2dc034e3812aa5fae5bb0819c74d',
      //       payLoad: '[]'
      //     },
      //     errorDetails: null
      //   }
      // };

      const responseData = this.parseResponseData(response.data);
      console.log('getAllAnsweredQuestions response', responseData);
      return responseData;
    } catch (error) {
      console.error('getAllAnsweredQuestions error', error);
      return null;
    }
  };

  submitApplication = async (productCode, data, turnOffLoading = false) => {
    console.log('network submitApplication', JSON.stringify(data));
    this.currentErrorCode = 'FE170';
    try {
      const response = await this.client.post(
        `api/${productCode}/policy/submitWithUnderwriteMeChecking`,
        data,
        { turnOffLoading }
      );

      const responseData = this.parseResponseData(response.data);
      console.log('submitApplication response', responseData);
      return responseData;
    } catch (error) {
      console.error('submitApplication error', error);
      return null;
    }
  };

  getMultiQuote = async (productCode, data, turnOffLoading = false) => {
    try {
      const requestData = this.stringifyRequestData(data);

      const response = await this.client.post(`api/${productCode}/multiQuotation`, requestData, {
        turnOffLoading
      });
      const responseData = this.parseResponseData(response.data);
      console.log('getMultiQuote response', responseData);
      return responseData;
    } catch (error) {
      console.error('getMultiQuote error', error);
      return null;
    }
  };

  getPromoCodeSummary = async (productCode, data, turnOffLoading = false) => {
    this.currentErrorCode = 'FE180';
    try {
      const response = await this.client.post(`/api/${productCode}/promoCode/getSummary`, data, {
        turnOffLoading
      });

      const responseData = this.parseResponseData(response.data);
      console.log('getPromoCodeSummary response', responseData);
      return responseData;
    } catch (error) {
      console.error('getPromoCodeSummary error', error);
      return null;
    }
  };

  quotationWithoutSave = async (productCode, data) => {
    this.currentErrorCode = 'FE200';
    console.log('quotationWithoutSave data:', JSON.stringify(data));
    const path = `/api/${productCode}/quotationWithoutSave`;
    const response = await this.doPost(path, data);
    return response;
  };

  checkoutForPayment = async (productCode, data) => {
    this.currentErrorCode = 'FE210';
    const path = `/api/${productCode}/policy/checkOutForPayment`;
    console.log('===checkOutForPayment data:', JSON.stringify(data));
    const response = await this.doPost(path, data);
    return response;
  };

  getPaymentInfo = async (productCode, data) => {
    this.currentErrorCode = 'FE220';
    const path = `/api/${productCode}/payment/info`;
    console.log('===getPaymentInfo data:', JSON.stringify(data));
    const response = await this.doPost(path, data);
    return response;
  };

  skipPaymentInfo = async (productCode, data) => {
    this.currentErrorCode = 'FE230';
    const path = `/api/${productCode}/skipPayment`;
    console.log('===skipPaymentInfo data:', JSON.stringify(data));
    const response = await this.doPost(path, data);
    return response;
  };

  documentUpload = async (productCode, planCode, policyRefNo, documentType, mimeType, content) => {
    // Construct form data for multipart request
    const formData = new FormData();
    formData.append('productCode', productCode);
    formData.append('planCode', planCode);
    formData.append('policyRefNo', policyRefNo);
    formData.append('documentType', documentType);
    formData.append('mimeType', mimeType);
    formData.append('content', content);

    // Override default headers
    const config = {
      headers: { 'Content-Type': 'multipart/form-data' }
    };
    this.currentErrorCode = 'FE240';

    try {
      const response = await this.client.post(
        `/api/${productCode}/documentUpload`,
        formData,
        config
      );
      if (!response || !response.data) {
        return null;
      }
      console.log('documentUpload response', response.data);
      return response.data;
    } catch (error) {
      console.error('documentUpload error', error.response.data);
      return error.response.data;
    }
  };

  retrieveSummary = async (productCode, data) => {
    // const isDebugEnabled = Config.debug.summary || false;
    console.log('network retrieveSummary', JSON.stringify(data));
    try {
      if (data.policyRefNo === 'DEMO') {
        return this.parseResponseData({
          result: 'SUCCESS',
          payLoad: [
            {
              referenceNo: 'X',
              commencementDate: null,
              lastDueDate: 'Oct 10, 2040',
              contribution: '327.00/annually',
              discountContribution: null,
              paymentTerm: 19,
              gracePeriod: null,
              policyStatus: 'PENDING',
              paymentStatus: 'SUCCESS',
              custList: [
                // {
                //   name: 'XXX',
                //   nRIC: 'XXXXXX-XX-XXXX',
                //   sumCoverage: 300000.0,
                //   upToAge: 43,
                //   term: 19,
                //   order: '1',
                //   gender: 'F',
                //   dob: 'XX-XX-XXXX',
                //   relationshipWithApplicant: 'SE',
                //   smokingInd: 'N',
                //   height: 60.0,
                //   weight: null,
                //   address: {
                //     address1: 'XXX',
                //     address2: 'XXX',
                //     address3: 'XXX',
                //     address4: 'XXXXX',
                //     address5: 'XXXXX',
                //     countryCodeItemDescCode: 'MY',
                //     fullAddress: null,
                //     zipCode: '81000',
                //     addressType: 'R'
                //   },
                //   telContact: {
                //     telType: 'M',
                //     telNo: '6666666666666',
                //     telNoCountryCode: '60',
                //     status: 'U'
                //   },
                //   emailId: ''
                // }
              ],
              productCode: 'termLife',
              planCode: 'BAS',
              riderSumInsured: 0,
              specialoffer: null,
              firstPaymentDate: null,
              quotationId: 77208,
              enquireKey: '2d2e288d8e5301b30e15dcb2e3cb7d28c7bbfdac'
            },
            {
              referenceNo: 'X',
              commencementDate: null,
              lastDueDate: null,
              contribution: null,
              discountContribution: null,
              paymentTerm: 19,
              gracePeriod: null,
              policyStatus: 'NEW',
              paymentStatus: null,
              custList: [
                // {
                //   name: 'XXX',
                //   nRIC: 'XXXXXX-XX-XXXX',
                //   sumCoverage: 300000.0,
                //   upToAge: 43,
                //   term: 19,
                //   order: '1',
                //   gender: 'F',
                //   dob: 'XX-XX-XXXX',
                //   relationshipWithApplicant: 'SE',
                //   smokingInd: 'N',
                //   height: 60.0,
                //   weight: null,
                //   address: {
                //     address1: 'XXX',
                //     address2: 'XXX',
                //     address3: 'XXX',
                //     address4: 'KULAI',
                //     address5: 'JOHOR',
                //     countryCodeItemDescCode: 'MY',
                //     fullAddress: null,
                //     zipCode: '81000',
                //     addressType: 'R'
                //   },
                //   telContact: {
                //     telType: 'M',
                //     telNo: '6666666666666',
                //     telNoCountryCode: '60',
                //     status: 'U'
                //   },
                //   emailId: ''
                // },
                // {
                //   name: 'SPOUSE',
                //   nRIC: 'XXXXXX-XX-XXXX',
                //   sumCoverage: 300000.0,
                //   upToAge: 38,
                //   term: 19,
                //   order: '2',
                //   gender: 'F',
                //   dob: 'XX-XX-XXXX',
                //   relationshipWithApplicant: 'SP',
                //   smokingInd: 'N',
                //   height: null,
                //   weight: null,
                //   address: {
                //     address1: 'XXXX',
                //     address2: null,
                //     address3: null,
                //     address4: 'KUALA LUMPUR',
                //     address5: 'WILAYAH PERSEKUTUAN KUALA LUMPUR',
                //     countryCodeItemDescCode: 'MY',
                //     fullAddress: null,
                //     zipCode: '50500',
                //     addressType: 'R'
                //   },
                //   telContact: {
                //     telType: 'M',
                //     telNo: '999999999',
                //     telNoCountryCode: '60',
                //     status: 'I'
                //   },
                //   emailId: ''
                // }
              ],
              productCode: 'termLife',
              planCode: 'BAS',
              riderSumInsured: 0,
              specialoffer: null,
              firstPaymentDate: null,
              quotationId: 82341,
              enquireKey: '48e8999cca3f49e775da13cd653e501b1ffde7dc'
            },
            {
              referenceNo: 'X',
              commencementDate: null,
              lastDueDate: null,
              contribution: null,
              discountContribution: null,
              paymentTerm: 19,
              gracePeriod: null,
              policyStatus: 'NEW',
              paymentStatus: null,
              custList: [
                // {
                //   name: 'XXX',
                //   nRIC: 'XXXXXX-XX-XXXX',
                //   sumCoverage: 300000.0,
                //   upToAge: 43,
                //   term: 19,
                //   order: '1',
                //   gender: 'F',
                //   dob: 'XX-XX-XXXX',
                //   relationshipWithApplicant: 'SE',
                //   smokingInd: 'N',
                //   height: 60.0,
                //   weight: null,
                //   address: {
                //     address1: 'XXX',
                //     address2: 'XXX',
                //     address3: 'XXX',
                //     address4: 'XXX',
                //     address5: 'XXX',
                //     countryCodeItemDescCode: 'MY',
                //     fullAddress: null,
                //     zipCode: '81000',
                //     addressType: 'R'
                //   },
                //   telContact: {
                //     telType: 'M',
                //     telNo: '6666666666666',
                //     telNoCountryCode: '60',
                //     status: 'U'
                //   },
                //   emailId: ''
                // },
                // {
                //   name: 'CHILD',
                //   nRIC: 'XXXXXX-XX-XXXX',
                //   sumCoverage: 300000.0,
                //   upToAge: 22,
                //   term: 19,
                //   order: '3',
                //   gender: 'M',
                //   dob: 'XX-XX-XXXX',
                //   relationshipWithApplicant: 'CH',
                //   smokingInd: 'N',
                //   height: null,
                //   weight: null,
                //   address: {
                //     address1: 'XXXX',
                //     address2: null,
                //     address3: null,
                //     address4: 'XXXX',
                //     address5: 'XXXX',
                //     countryCodeItemDescCode: 'MY',
                //     fullAddress: null,
                //     zipCode: '50500',
                //     addressType: 'R'
                //   },
                //   telContact: null,
                //   emailId: null
                // }
              ],
              productCode: 'termLife',
              planCode: 'BAS',
              riderSumInsured: 0,
              specialoffer: null,
              firstPaymentDate: null,
              quotationId: 82350,
              enquireKey: 'aebeff1731204fdb877653322561947e41adf1b7'
            }
          ],
          errorDetails: null
          
        });
      } else {
        this.currentErrorCode = 'FE250';
        const response = await this.client.post(`api/${productCode}/policy/getSummary`, data);
        console.error('00000000response', response);
        const responseData = this.parseResponseData(response.data);
        await console.error('retrieveSummary response--------', responseData);
        return responseData;
      }
    } catch (error) {
      console.error('retrieveSummary error', error);
      return error.response.data;
    }
  };

  sendOTP = async (policyRefNo, telNum, countryCode) => {
    this.currentErrorCode = 'FE260';
    try {
      const response = await this.client.post(`api/otp/send`, {
        policyRefNo,
        telNum,
        countryCode: '+' + countryCode,
        type: 'eNorm',
        expiryDuration: '300'
      });
      return response.data;
    } catch (error) {
      console.error('sendOTP error', error);
      return error.response.data;
    }
  };

  validateOTP = async (policyRefNo, otpInput) => {
    this.currentErrorCode = 'FE270';
    try {
      const response = await this.client.post(`api/otp/validate`, {
        policyRefNo,
        otpInput,
        type: 'eNorm'
      });
      return response.data;
    } catch (error) {
      console.error('validateOTP error', error);
      return error.response.data;
    }
  };

  contactLater = async (productCode, data) => {
    this.currentErrorCode = 'FE280';
    const path = `/api/${productCode}/policy/contactLater`;
    const response = await this.doPost(path, data);
    return response;
  };

  updateNominateInfo = async (productCode, data) => {
    this.currentErrorCode = 'FE290';
    const path = `/api/${productCode}/policy/updateNominateInformation`;
    console.log('===updateNominateInfo data:', JSON.stringify(data));
    const response = await this.doPost(path, data);
    return response;
  };

  submitTelemarketing = async (productCode, data) => {
    this.currentErrorCode = 'FE300';
    console.log('network submitTelemarketing', JSON.stringify(data));
    const path = `api/${productCode}/policy/submitForTeleMarketing`;
    const response = await this.doPost(path, data);
    return response;
  };

  validateTelemarketingSMS = async (data) => {
    this.currentErrorCode = 'FE310';
    console.log('network validateTelemarketingSMS', JSON.stringify(data));
    const path = 'api/payLater/validate';
    const response = await this.doPost(path, data);
    return response;
  };

  resendTelemarketingSMS = async (data) => {
    this.currentErrorCode = 'FE320';
    console.log('network resendTelemarketingSMS', JSON.stringify(data));
    const path = 'api/payLater/send';
    const response = await this.doPost(path, data);
    return response;
  };

  getPaymentUrlForTelemarketing = async (data) => {
    this.currentErrorCode = 'FE350';
    console.log('network getPaymentUrlForTelemarketing', JSON.stringify(data));
    const path = 'api/payLater/paymentUrl';
    const response = await this.doPost(path, data);
    return response;
  };

  saveLead = async (productCode, data) => {
    this.currentErrorCode = 'FE330';
    const path = `/api/${productCode}/leadStorage`;
    const response = await this.doPost(path, data);
    return response;
  };

  getEPFPrelimSummary = async (productCode, data) => {
    const path = `/api/${productCode}/policy/getSummary`;
    const response = await this.doPost(path, data);
    return response;
  };

  getSummaryByMainPolicy = async (productCode, data) => {
    const path = `/api/${productCode}/policy/getSummaryByMainPolicy`;
    const response = await this.doPost(path, data);
    return response;
  };

  getSummaryByMainPolicyPhase2 = async (productCode, data) => {
    const path = `/api/${productCode}/policy/getSummaryByMainPolicy`;

    let response = await this.doPost(path, data);
    if (!response || !response.payLoad) {
      this.eventEmitter.emit(EventType.loading, true);
      await new Promise((resolve) => setTimeout(resolve, 5000));
      response = await this.doPost(path, data);
      this.eventEmitter.emit(EventType.loading, false);
    }
    if (!response || !response.payLoad) {
      this.eventEmitter.emit(EventType.loading, true);
      await new Promise((resolve) => setTimeout(resolve, 5000));
      response = await this.doPost(path, data);
      this.eventEmitter.emit(EventType.loading, false);
    }

    return response;
  };

  checkoutForEPFGateway = async (productCode, data) => {
    this.currentErrorCode = 'FE340';
    const path = `/api/${productCode}/policy/checkoutForPaymentForEPFPaymentGateway`;
    console.log('===checkOutForPayment data:', JSON.stringify(data), data);
    const response = await this.doPost(path, data);
    return response;
  };

  checkoutForPaymentForEPFByMainPolicy = async (productCode, data) => {
    this.currentErrorCode = 'FE340';
    const path = `/api/${productCode}/policy/checkoutForPaymentForEPFPaymentGatewayByMainPolicy`;
    console.log('===checkOutForPayment data:', JSON.stringify(data), data);
    const response = await this.doPost(path, data);
    return response;
  };

  doPost = async (path, data) => {
    const requestData = this.stringifyRequestData(data);

    try {
      const response = await this.client.post(path, requestData);
      if (!response || !response.data) {
        return null;
      }

      const responseData = this.parseResponseData(response.data);
      console.log('API response', responseData);
      return responseData;
    } catch (error) {
      console.error('API error', error);
      return null;
    }
  };

  getJWTByPolicy = async (data) => {
    const path = `/api/policy/getJWTByPolicy`;
    const response = await this.doPost(path, data);
    return response;
  };

  navigateToIProtect = async (
    purchaseStatus,
    purchaseStatusCode,
    transactionOrigin,
    isNewProduct,
    policyRefNoByRouter
  ) => {
    transactionOrigin = transactionOrigin || '';
    const policyRefNo = AppStorage.getItem('PolicyRefNoPayload') || policyRefNoByRouter;
    const response = await this.getJWTByPolicy({ policyRefNo: policyRefNo, payLoad: '' });
    const JWTString = response.payLoad;
    const jwtEncryptedPayLoadObject = JSON.parse(JWTString);
    const storagePayload = getEPFPayloadnew(jwtEncryptedPayLoadObject.jwtEncryptedPayLoad);

    console.log('storagePayload::::', storagePayload);

    // TODO move these configs to config files
    const path = Config.epfITO;
    const institutionCode = Config.epfInstitutionCode;
    let encodedPayload;

    encodedPayload = signWithJwt(
      mapPayloadNewProduct({
        ...storagePayload,
        purchaseStatus,
        purchaseStatusCode,
        transactionOrigin
      })
    );

    console.log('encodedPayload:::::', encodedPayload);
    try {
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = path;
      // add first field
      const field1 = document.createElement('input');
      field1.type = 'hidden';
      field1.name = 'encoded';
      field1.value = encodedPayload;
      form.appendChild(field1);

      const field2 = document.createElement('input');
      field2.type = 'hidden';
      field2.name = 'institutionCode';
      field2.value = institutionCode;
      form.appendChild(field2);

      document.body.appendChild(form);
      form.submit();
      AppStorage.clear();
    } catch (err) {
      console.error('NavigateToIProtect error', err);
    }
  };

  blackListCheck = async (fullName, dob, gender, idNo) => {
    const path = `/api/customer/blackListCheck`;
    const idNumber = idNo;
    const data = {
      payLoad: {
        fullName,
        dob,
        gender,
        idNumber
      }
    };

    try {
      const response = await this.doPost(path, data);
      if (response.result === 'SUCCESS') {
        const { blackListInd, reasons } = response.payLoad;
        return {
          blackListed: blackListInd !== 'N',
          reasons
        };
      }
      return {
        blackListed: false,
        reasons: 'api call failed'
      };
    } catch (err) {
      console.log('BlackListCheck from BE failed');
      return {
        blackListed: false,
        reasons: 'api call failed'
      };
    }
  };

  externalPartnerAccessLogToCreateQuoteAndPolicy = async (payload) => {
    const path = `/direct/epf/navigateToITO`;

    let clientTest = axios.create({
      baseURL: 'http://20.43.172.115',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      proxy: false

      // transformResponse: [
      //   data => {
      //     try {
      //       let obj = JSON.parse(data);

      //       // Payload contains an escaped json string
      //       // Parse it back into object if it is present
      //       if (obj.payload !== undefined && obj.payload !== null) {
      //         obj.payload = JSON.parse(obj.payload);
      //       }
      //       return obj;
      //     } catch (e) {
      //       // Cannot parse as json, something is probably wrong
      //       return data;
      //     }
      //   }
      // ]
    });
    try {
      const response = await clientTest.post(path, querystring.stringify({ encoded: payload }));
      return response?.data ? response.data : null;
    } catch (err) {
      console.log('externalPartnerAccessLogToCreateQuoteAndPolicy failed in BE');
      console.log(err.message);
      return null;
    }
  };
}

export default Network;
